// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import {
  ADD_EVENT_ID_FAIL,
  ADD_EVENT_ID_REQUEST,
  ADD_EVENT_ID_SUCCESS,
  ADD_REQUEST_QUOTE_FAIL,
  ADD_REQUEST_QUOTE_REQUEST,
  ADD_REQUEST_QUOTE_SUCCESS,
  ADD_SESSION_ID_TO_EVENT_FAIL,
  ADD_SESSION_ID_TO_EVENT_REQUEST,
  ADD_SESSION_ID_TO_EVENT_SUCCESS,
  ADD_SESSION_POSITION_FAIL,
  ADD_SESSION_POSITION_REQUEST,
  ADD_SESSION_POSITION_SUCCESS,
  ADD_SESSION_TO_POSITION_BOARD,
  CLEAR_SESSION_DATA,
  CLEAR_SESSION_STEP1_DATA,
  CLEAR_SESSION_STEP_2_FORM,
  CREATE_CONTACT_INFO_FAIL,
  CREATE_CONTACT_INFO_REQUEST,
  CREATE_CONTACT_INFO_SUCCESS,
  CREATE_EVENT_INFO_FAIL,
  CREATE_EVENT_INFO_REQUEST,
  CREATE_EVENT_INFO_SUCCESS,
  CREATE_SESSION_POSITION_FAIL,
  CREATE_SESSION_POSITION_REQUEST,
  CREATE_SESSION_POSITION_SUCCESS,
  CREATE_SESSION_STEP1_FAIL,
  CREATE_SESSION_STEP1_REQUEST,
  CREATE_SESSION_STEP1_SUCCESS,
  DELETE_SESSION_FAIL,
  DELETE_SESSION_POSITIONS_OF_GIVEN_SESSION,
  DELETE_SESSION_POSITION_FAIL,
  DELETE_SESSION_POSITION_REQUEST,
  DELETE_SESSION_POSITION_SUCCESS,
  DELETE_SESSION_REQUEST,
  DELETE_SESSION_SUCCESS,
  EMPTY_POSITION_BOARD,
  GET_ALL_POSITIONS_FAIL,
  GET_ALL_SESSIONS_POSITIONS_REQUEST,
  GET_ALL_SESSIONS_POSITIONS_SUCCESS,
  GET_POSITIONS_BY_NAME_FAIL,
  GET_POSITIONS_BY_NAME_REQUEST,
  GET_POSITIONS_BY_NAME_SUCCESS,
  GET_SESSIONS_FOR_SPECIFIC_EVENT_FAIL,
  GET_SESSIONS_FOR_SPECIFIC_EVENT_REQUEST,
  GET_SESSIONS_FOR_SPECIFIC_EVENT_SUCCESS,
  REMOVE_SESSION_FROM_POSITION_BOARD,
  RESET_CREATE_EVENT_SLICE,
  SET_CONTACT_INFO_FORM,
  SET_CURRENT_EDITABLE_POSITION,
  SET_EVENT_INFO_FORM,
  SET_FORM_AS_PARTIAL_EVENT,
  SET_SESSION_DATA,
  SET_SESSION_STEP_1_FORM,
  SET_SESSION_STEP_2_FORM,
  SKIP_SESSION_STEP1_FAIL,
  SKIP_SESSION_STEP1_REQUEST,
  SKIP_SESSION_STEP1_SUCCESS,
  TOGGLE_POSITION_BUTTON_TIMELINE,
  UPDATE_CONTACT_INFO_FAIL,
  UPDATE_CONTACT_INFO_REQUEST,
  UPDATE_CONTACT_INFO_SUCCESS,
  UPDATE_CURRENT_SESSION_STEP1,
  UPDATE_EVENT_INFO_FAIL,
  UPDATE_EVENT_INFO_REQUEST,
  UPDATE_EVENT_INFO_SUCCESS,
  UPDATE_SESSION_POSITION_FAIL,
  UPDATE_SESSION_POSITION_REQUEST,
  UPDATE_SESSION_POSITION_SUCCESS,
  UPDATE_SESSION_STEP1_DATA,
  UPDATE_SESSION_STEP1_FAIL,
  UPDATE_SESSION_STEP1_REQUEST,
  UPDATE_SESSION_STEP1_SUCCESS,
  UPDATE_SUBMITTED_KEY_FAIL,
  UPDATE_SUBMITTED_KEY_REQUEST,
  UPDATE_SUBMITTED_KEY_SUCCESS
} from "../constants/createEvent";
import { ALERT_DIALOG } from "../constants/auth";

import { addEditLogAction, addLogAction } from "./logs";
import { sessionObjToFormObjHandler } from "../../pages/create-event/components/sessions/sessionHandlers";
import { alertDialogAciton, alertDialogCloseAction } from "./auth";
import { generateDateTableForReimWarning } from "../../utils/styles/defaultStyles";
import { abandonAssistantConversation } from "../../api/eventAssistant";

export const createContactInfoAction = (payload, successCallback, formData) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_CONTACT_INFO_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `createContactInformation`,
      data: payload,
      isToken: false,
    });

    if (response) {
      dispatch({
        type: CREATE_CONTACT_INFO_SUCCESS,
        payload: {
          res: response?.data,
          formData
        }
      });
      successCallback();
    } else if (error) {
      dispatch({ type: CREATE_CONTACT_INFO_FAIL });
    }
  };
};

export const updateContactInfoAction = ({
  payload,
  _id,
  successCallback,
  formData
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_CONTACT_INFO_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateContactInformation/${_id}`,
      data: payload,
      // isToken: true
      isToken: Boolean(getState()?.auth?.userToken),
    });

    if (response) {
      dispatch({
        type: UPDATE_CONTACT_INFO_SUCCESS,
        payload: {
          res: response?.data,
          formData
        }
      });
      successCallback();
    } else if (error) {
      dispatch({ type: UPDATE_CONTACT_INFO_FAIL });
    }
  };
};

export const createEventInfoAction = ({
  payload,
  successCallback,
  formData,
  userAuth
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: CREATE_EVENT_INFO_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `createEvent`,
      data: payload,
      // isToken: Boolean(userAuth?.userToken)
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({
        type: CREATE_EVENT_INFO_SUCCESS,
        payload: {
          res: response?.data,
          formData
        }
      });

      if (userAuth?.userToken) {
        dispatch(
          addLogAction({
            id: response?.data?.data?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              description: `${response?.data?.data?.eventName} event is added`
            }
          })
        );
      }

      successCallback({
        eventInfo: response?.data?.data
      });
    } else if (error) {
      dispatch({ type: CREATE_EVENT_INFO_FAIL });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error!",
          message: error?.response?.data?.message
        }
      });
    }
  };
};

export const addEventIdAction = ({
  contactInformationId,
  payload,
  successCallback
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_EVENT_ID_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `addEventId/${contactInformationId}`,
      data: payload,
      isToken: true
    });
    if (response) {
      dispatch({ type: ADD_EVENT_ID_SUCCESS, payload: null });
      successCallback ? successCallback() : null;
    } else if (error) {
      dispatch({ type: ADD_EVENT_ID_FAIL });
    }
  };
};

export const updateEventInfoAction = ({
  initialValues,
  changedValues,
  description,
  payload,
  _id,
  successCallback,
  formData,
  userAuth
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_EVENT_INFO_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateEvent/${_id}`,
      data: payload,
      // isToken: userAuth?.userToken ? true : false
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({
        type: UPDATE_EVENT_INFO_SUCCESS,
        payload: {
          res: response?.data,
          formData
        }
      });

      if (userAuth?.userToken && description) {
        dispatch(
          addEditLogAction({
            id: response?.data?.data?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              eventId: _id,
              description,
              previousValues: initialValues,
              updatedValues: changedValues
            }
          })
        );
      }

      successCallback();
    } else if (error) {
      dispatch({ type: UPDATE_EVENT_INFO_FAIL });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error!",
          message: error?.response?.data?.message
        }
      });
    }
  };
};

export const updateSubmittedKey = ({
  successCallback,
  failureCallback,
  eventId,
  payload,
  userAuth
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_SUBMITTED_KEY_REQUEST });

    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `submitEvent`,
      params: {
        eventId
      },
      data: payload,
      // isToken: Boolean(userAuth?.userToken)
      isToken: Boolean(getState()?.auth?.userToken),
    });

    if (response) {
      dispatch({ type: UPDATE_SUBMITTED_KEY_SUCCESS, payload: null });
      // dispatch(getAllSessionsPositions(response.data.data._id))
      successCallback ? successCallback() : null;
    } else if (error) {
      dispatch({ type: UPDATE_SUBMITTED_KEY_FAIL });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

export const createSessionStep1Action = ({
  payload,
  successCallback,
  formData,
  afterCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: CREATE_SESSION_STEP1_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `createSession`,
      data: payload,
      isToken: Boolean(getState()?.auth?.userToken)
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      // dispatch({
      //   type: CREATE_SESSION_STEP1_SUCCESS,
      //   payload: {
      //     res: response?.data,
      //     formData,
      //   },
      // });

      if (getState()?.auth?.userToken) {
        dispatch(
          addLogAction({
            id: payload?.eventId,
            payload: {
              actionById: getState()?.auth?.userId,
              sessionId: response?.data?.data?._id,
              description: `${response?.data?.data?.sessionName} session is added`
            }
          })
        );
      }

      dispatch(getAllSessionsPositions(response.data.data._id));
      successCallback({
        response,
        session: response?.data?.data,
        sessionId: [response?.data?.data?._id]
      });
    } else if (error) {
      dispatch({ type: CREATE_SESSION_STEP1_FAIL });
      if (failureCallback) failureCallback();
    }
  };
};

export const addSessionIdToEventAction = ({
  eventId,
  payload,
  successCallback,
  userAuth
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: ADD_SESSION_ID_TO_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `addSessionIdToEvent/${eventId}`,
      data: payload,
      // isToken: Boolean(userAuth?.userToken)
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({ type: ADD_SESSION_ID_TO_EVENT_SUCCESS, payload: null });
      successCallback ? successCallback() : null;
    } else if (error) {
      dispatch({ type: ADD_SESSION_ID_TO_EVENT_FAIL });
    }
  };
};

export const updateSessionStep1Action = ({
  eventInfo,
  initialValues,
  changedValues,
  description,
  payload,
  id,
  successCallback,
  formData
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_SESSION_STEP1_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateSessionData/${id}`,
      data: payload,
      // isToken: Boolean(eventInfo?.userId)
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({
        type: UPDATE_SESSION_STEP1_SUCCESS,
        payload: {
          data: {
            ...payload,
            _id: id
          },
          res: response?.data?.data,
          formData
        }
      });

      if (getState()?.auth?.userId && description) {
        dispatch(
          addEditLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              sessionId: id,
              previousValues: initialValues,
              updatedValues: changedValues,
              description
            }
          })
        );
      }

      dispatch(getAllSessionsPositions(id));
      successCallback();
    } else if (error) {
      dispatch({ type: UPDATE_SESSION_STEP1_FAIL });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error!",
          message:
            error?.response?.data?.message ||
            `Some error occured in editing the session`
        }
      });
    }
  };
};

export const skipSessionStep1Action = ({
  eventInfo,
  initialValues,
  changedValues,
  description,
  payload,
  id,
  successCallback,
  formData
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: SKIP_SESSION_STEP1_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `addSkippedSession`,
      data: payload,
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({
        type: SKIP_SESSION_STEP1_SUCCESS,
        payload: {
          data: payload,
          res: {
            ...response?.data?.data,
            sessionPoint: response?.data?.data?.sessionContactPoint,
            contact: response?.data?.data?.mobile,
            location: response?.data?.data?.venue
          },
          formData
        }
      });

      // if (getState()?.auth?.userId) {
      //   dispatch(
      //     addEditLogAction({
      //       id: eventInfo?._id,
      //       payload: {
      //         actionById: getState()?.auth?.userId,
      //         sessionId: id,
      //         previousValues: initialValues,
      //         updatedValues: changedValues,
      //         description
      //       }
      //     })
      //   );
      // }

      if (successCallback) {
        successCallback({
          sessionId: response?.data?.data?._id
        });
      }
    } else if (error) {
      dispatch({ type: SKIP_SESSION_STEP1_FAIL });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error!",
          message:
            error?.response?.data?.message ||
            `Some error occured in editing the session`
        }
      });
    }
  };
};

export const setSessionData = ({ session }) => {
  return {
    type: SET_SESSION_DATA,
    payload: {
      session
    }
  };
};

export const clearSessionData = () => {
  return {
    type: CLEAR_SESSION_DATA
  };
};

export const contactInfoFormAction = ({ payload }) => {
  return {
    type: SET_CONTACT_INFO_FORM,
    payload
  };
};

export const setEventInfoFormAction = ({ payload }) => {
  return {
    type: SET_EVENT_INFO_FORM,
    payload
  };
};

export const setSessionStep1FormAction = ({ payload }) => {
  return {
    type: SET_SESSION_STEP_1_FORM,
    payload
  };
};

export const clearSessionStep1DataAction = () => {
  return {
    type: CLEAR_SESSION_STEP1_DATA
  };
};

export const updateSessionStep1DataAction = ({ payload }) => {
  return {
    type: UPDATE_SESSION_STEP1_DATA,
    payload
  };
};

export const setSessionStep2FormAction = ({ payload }) => {
  return {
    type: SET_SESSION_STEP_2_FORM,
    payload
  };
};

export const clearSessionStep2FormAction = ({ payload }) => {
  return {
    type: CLEAR_SESSION_STEP_2_FORM,
    payload
  };
};

// export const getAllPositions = () => {
//   return async (dispatch) => {
//     dispatch({ type: GET_ALL_POSITIONS_REQUEST });
//     const { response, error } = await apiRequest({
//       method: "GET",
//       url: `fetchPositions`,
//       isToken: false
//     });
//     if (response) {
//       dispatch({
//         type: GET_ALL_POSITIONS_SUCCESS,
//         payload: {
//           positions: response.data?.data?.positions
//         }
//       });
//     } else if (error) {
//       dispatch({ type: GET_ALL_POSITIONS_FAIL });
//     }
//   };
// };

export const getSearchPositions = (positionName) => {
  return async (dispatch) => {
    dispatch({ type: GET_POSITIONS_BY_NAME_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: positionName
        ? `fetchPositionByName?positionName=${positionName}`
        : `fetchPositionByName`,
      isToken: false
    });
    if (response) {
      dispatch({
        type: GET_POSITIONS_BY_NAME_SUCCESS,
        payload: {
          positions: response.data?.data
        }
      });
    } else if (error) {
      dispatch({ type: GET_POSITIONS_BY_NAME_FAIL });
    }
  };
};

export const createPositionAction = (payload, successCallback) => {
  return async (dispatch, getState) => {
    dispatch({ type: CREATE_SESSION_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `createPosition`,
      data: payload,
      // isToken: false
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({
        type: CREATE_SESSION_POSITION_SUCCESS,
        payload: response.data
      });
      successCallback();
    } else if (error) {
      dispatch({ type: CREATE_SESSION_POSITION_FAIL });
    }
  };
};

export const addPositionAction = ({
  sessionId,
  eventInfo,
  payload,
  successCallback,
  formData
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: ADD_SESSION_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `addPosition/${sessionId}`,
      data: payload,
      // isToken: Boolean(eventInfo?.userId)
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({
        type: ADD_SESSION_POSITION_SUCCESS,
        payload: {
          res: response?.data,
          formData
        }
      });

      dispatch({
        type: CLEAR_SESSION_STEP_2_FORM
      });

      if (getState()?.auth?.userToken) {
        dispatch(
          addLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              positionId:
                response?.data?.Session?.position?.[
                  response?.data?.Session?.position?.length - 1
                ]?.positionData?.[0]?._id,
              description: `${
                response?.data?.Session?.position?.[
                  response?.data?.Session?.position?.length - 1
                ]?.positionData?.[0]?.positionName
              } position is added`
            }
          })
        );
      }

      successCallback();
    } else if (error) {
      dispatch({ type: ADD_SESSION_POSITION_FAIL });
    }
  };
};

export const addMultiplePositionAction = ({
  sessionId,
  eventInfo,
  payload,
  positions,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }
    const { response, error } = await apiRequest({
      method: "POST",
      url: `addMultiplePositions/${sessionId}`,
      data: payload,
      // isToken: Boolean(eventInfo?.userId)
      isToken: Boolean(getState()?.auth?.userToken),
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      dispatch({
        type: CLEAR_SESSION_STEP_2_FORM
      });

      if (getState()?.auth?.userToken) {
        dispatch(
          addLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              positionIds: positions?.map?.((position) => position?._id),
              description: `${
                payload?.positions?.[0]?.quantity > 1 ? "(" : ""
              }${positions
                ?.map?.((position) => position?.positionName)
                ?.join(", ")}${
                payload?.positions?.[0]?.quantity > 1
                  ? `${
                      positions?.length > 1
                        ? `) * ${payload?.positions?.[0]?.quantity}`
                        : ` * ${payload?.positions?.[0]?.quantity})`
                    }`
                  : ""
              } ${
                positions?.length === 1
                  ? "position is added"
                  : "positions are added"
              }`
            }
          })
        );
      }

      successCallback({
        response
      });
    } else if (error) {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

export const updatePositionAction = ({
  initialValues,
  changedValues,
  description,
  sessionId,
  eventInfo,
  payload,
  successCallback
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_SESSION_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updatePosition/${sessionId}`,
      data: payload,
      // isToken: Boolean(eventInfo?.userId)
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({
        type: UPDATE_SESSION_POSITION_SUCCESS,
        payload: response.data
      });

      dispatch({
        type: CLEAR_SESSION_STEP_2_FORM
      });

      if (getState()?.auth?.userToken) {
        dispatch(
          addEditLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              positionId:
                response?.data?.responseData?.position?.[0]?.positionData?.[0]
                  ?._id,
              previousValues: initialValues,
              updatedValues: changedValues,
              description
            }
          })
        );
      }

      if (successCallback) {
        successCallback();
      }
    } else if (error) {
      dispatch({ type: UPDATE_SESSION_POSITION_FAIL });
    }
  };
};

export const deletePositionAction = ({
  sessionId,
  position,
  eventInfo,
  payload,
  successCallback,
  failureCallback,
  auth
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: DELETE_SESSION_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `deletePosition/${sessionId}`,
      data: payload,
      // isToken: Boolean(auth?.userToken)
      isToken: Boolean(getState()?.auth?.userToken)
    });
    if (response) {
      dispatch({
        type: DELETE_SESSION_POSITION_SUCCESS,
        payload: {
          sessionId,
          individualPositionId: payload?.id
        }
      });

      if (auth?.userToken) {
        dispatch(
          addLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              positionId: position?._id,
              description: `${position?.positionName} position is deleted`
            }
          })
        );
      }

      successCallback ? successCallback() : null;
    } else if (error) {
      dispatch({ type: DELETE_SESSION_POSITION_FAIL });
      if (failureCallback) failureCallback();
    }
  };
};

export const getAllSessionsPositions = (sessionId) => {
  return async (dispatch) => {
    dispatch({ type: GET_ALL_SESSIONS_POSITIONS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getSessionPositions/${sessionId}`,
      isToken: false
    });
    if (response) {
      dispatch({
        type: GET_ALL_SESSIONS_POSITIONS_SUCCESS,
        payload: {
          sessionPositions:
            response?.data?.data?.positions?.map((sessionPosition) => {
              return {
                ...sessionPosition,
                sessionId
              };
            }) || []
          // session: {
          //     _id: response?.data?.data?.positions?.[0]?.sessionId,
          //     positions: response?.data?.data?.positions?.map(sessionPosition => {
          //         return {
          //             ...sessionPosition,
          //             sessionId
          //         }
          //     }) || []
          // }
        }
      });
    } else if (error) {
      dispatch({ type: GET_ALL_POSITIONS_FAIL });
    }
  };
};

export const getSessionssOfSpecificEvent = (eventId, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: GET_SESSIONS_FOR_SPECIFIC_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getSessionsOfSpecificEvent/${eventId}`,
      isToken: true
    });

    if (response) {
      if (!Array.isArray(response?.data?.data)) {
        dispatch({ type: GET_SESSIONS_FOR_SPECIFIC_EVENT_FAIL });
        return { response: null, error: new Error("The event sessions could not be loaded. Please try again.") };
      }
      dispatch({
        type: GET_SESSIONS_FOR_SPECIFIC_EVENT_SUCCESS,
        // This is temporary, payload should be response.data instead...
        payload: {
          ...response?.data,
          data: response?.data?.data?.map((item) => {
            return {
              ...item,
              position: (Array.isArray(item?.position) ? item.position : []).map((currPosition) => {
                return {
                  ...currPosition,
                  positionData: (Array.isArray(currPosition?.positionData) ? currPosition.positionData : []).filter(
                    (individualPosition) => {
                      return !individualPosition?.isDeleted;
                    }
                  )
                };
              })
            };
          })
        }
        // This is temporary, payload should be response.data instead...
      });
      successCallback
        ? successCallback({
            response
          })
        : null;
    } else if (error) {
      dispatch({ type: GET_SESSIONS_FOR_SPECIFIC_EVENT_FAIL });
    }
    return { response, error };
  };
};

export const deleteSessionAction = ({
  payload,
  sessionId,
  session,
  eventInfo,
  successCallback,
  failureCallback,
  afterRequestCallback
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: DELETE_SESSION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `deleteSession/${sessionId}`,
      data: payload,
      // isToken: Boolean(eventInfo?.userId)
      isToken: Boolean(getState()?.auth?.userToken)
    });

    if (afterRequestCallback) {
      afterRequestCallback();
    }

    if (response) {
      dispatch({ type: DELETE_SESSION_SUCCESS, payload: sessionId });
      dispatch({
        type: DELETE_SESSION_POSITIONS_OF_GIVEN_SESSION,
        payload: {
          sessionId
        }
      });

      if (getState()?.auth?.userToken) {
        dispatch(
          addLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              sessionId,
              description: `${session?.sessionName} session is deleted`
            }
          })
        );
      }

      successCallback
        ? successCallback({
            sessionId
          })
        : null;
    } else if (error) {
      dispatch({ type: DELETE_SESSION_FAIL });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error!",
          message: error?.response?.data?.message
        }
      });

      if (failureCallback) {
        failureCallback();
      }
    }
  };
};

export const addRequestQuoteAction = ({
  payload,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: ADD_REQUEST_QUOTE_REQUEST });

    const { response, error } = await apiRequest({
      method: "POST",
      url: `requestQuote`,
      data: payload,
      // isToken: Boolean(eventInfo?.userId)
      isToken: Boolean(getState()?.auth?.userToken)
    });

    if (response) {
      dispatch({ type: ADD_REQUEST_QUOTE_SUCCESS });
      if (successCallback) {
        successCallback();
      }
    } else {
      dispatch({ type: ADD_REQUEST_QUOTE_FAIL });
      failureCallback
        ? failureCallback({
            error: error?.response
          })
        : null;
    }
  };
};

export const triggerRequestQuoteEmail = ({
  payload,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    // dispatch({ type: ADD_REQUEST_QUOTE_REQUEST });

    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `triggerRequestQuoteEmails`,
      data: payload,
      // isToken: Boolean(eventInfo?.userId)
      isToken: Boolean(getState()?.auth?.userToken)
    });

    // if (response) {
    //   dispatch({ type: ADD_REQUEST_QUOTE_SUCCESS });
    //   if (successCallback) {
    //     successCallback();
    //   }
    // } else {
    //   dispatch({ type: ADD_REQUEST_QUOTE_FAIL });
    //   failureCallback
    //     ? failureCallback({
    //         error: error?.response,
    //       })
    //     : null;
    // }
  };
};

export const getEventTimezoneAction = ({
  payload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async () => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      url: `getEventTimezone`,
      data: payload,
      method: "POST",
      isToken: true
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

export const submitEventBySheetAction = ({
  payload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback
}) => {
  return async () => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      url: `submitEventBySheet`,
      data: payload,
      method: "POST",
      isToken: true
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      if (successCallback) {
        successCallback({
          response
        });
      }
    } else {
      if (failureCallback) {
        failureCallback({
          error
        });
      }
    }
  };
};

export const setCurrentSessionData = (data) => {
  return {
    type: UPDATE_CURRENT_SESSION_STEP1,
    payload: { data }
  };
};

export const setCurrentPositionData = (data) => {
  return {
    type: SET_CURRENT_EDITABLE_POSITION,
    payload: { data }
  };
};

export const resetCreateEventSlice = () => {
  return {
    type: RESET_CREATE_EVENT_SLICE
  };
};

/** True when the Create Event tab holds a build in progress (typed or saved). */
export const hasCreateEventInProgress = (createContactInfo) =>
  Boolean(
    createContactInfo?.contactInfoForm ||
      createContactInfo?.eventInfoForm ||
      createContactInfo?.contactInfo ||
      createContactInfo?.eventInfo ||
      createContactInfo?.sessionsOfEvent?.length
  );

/**
 * The back arrow of the Create Event tab (Dashboard, All Events, Event
 * Requests, …). Leaving discards the build in progress — the same as the
 * wizard's Reset, chat included — so it asks first. Steps already completed
 * were saved by the wizard and stay under the draft events; only what was
 * not saved yet is lost. Nothing in progress → closes without asking.
 */
export const confirmAndCloseCreateEventAction = (onClose) => {
  return (dispatch, getState) => {
    if (!hasCreateEventInProgress(getState()?.createContactInfo)) {
      onClose?.();
      return;
    }
    dispatch({
      type: ALERT_DIALOG,
      payload: {
        open: true,
        title: "Leave event creation?",
        message:
          "Unsaved changes will be lost. Steps you already completed were saved and stay under the draft events.",
        okLabel: "Leave",
        closeLabel: "Stay",
        onOk: () => {
          dispatch(resetCreateEventSlice());
          if (getState()?.auth?.userToken) {
            abandonAssistantConversation().catch(() => undefined);
          }
          onClose?.();
        }
      }
    });
  };
};

// position board
export const addSessionToPositionBoardAction = ({ payload }) => {
  return {
    type: ADD_SESSION_TO_POSITION_BOARD,
    payload: payload?.sessionId
  };
};

export const removeSessionToPositionBoardAction = ({ payload }) => {
  return {
    type: REMOVE_SESSION_FROM_POSITION_BOARD,
    payload: payload?.sessionId
  };
};

export const emptyPositionBoardAction = () => {
  return {
    type: EMPTY_POSITION_BOARD
  };
};

// toggle edit button on timeline action
export const toggleEditButtonTimelineAction = (bool) => {
  return {
    type: TOGGLE_POSITION_BUTTON_TIMELINE,
    payload: bool
  };
};

// delete multiple positions action
export const deleteMultiplePositionAction = ({
  payload,
  successCallback,
  failureCallback,
  afterCallback,
  params,
  stopAutoSave,
  onResumeAutoSave
}) => {
  return async (dispatch, getState) => {
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "deleteMultiplePositions",
      data: {
        anyway: false,
        ...payload
      },
      params,
      isToken: Boolean(getState()?.auth?.userToken)
    });

    if (response?.status === 200) {
      if (
        response?.data?.reimbursementAttached ||
        response?.data?.contractorReimbursementAttached
      ) {
        stopAutoSave?.();
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Warning",
            message: generateDateTableForReimWarning({
              isReimb: response?.data?.reimbursementAttached || false,
              list: response?.data?.reimbursementAttachedPositions
                ?.reimbursementAttachedPositions,
              message: response?.data?.reimbursementAttachedPositions?.message,
              isLastCont:
                response?.data?.contractorReimbursementAttached || false,
              contList:
                response?.data?.reimbursementAttachedToContractors
                  ?.reimbursementAttachedToContractors,
              lastContMessage:
                response?.data?.reimbursementAttachedToContractors?.message
            }),
            okLabel: "Delete Anyway",
            onOk: () => {
              dispatch(alertDialogCloseAction({}));
              dispatch(
                deleteMultiplePositionAction({
                  payload: { ...payload, anyway: true },
                  successCallback,
                  failureCallback,
                  afterCallback,
                  params
                })
              );
              afterCallback?.();
            },
            onClose: () => {
              if (!stopAutoSave) {
                successCallback?.(response);
              } else if (onResumeAutoSave) {
                onResumeAutoSave?.(
                  response?.data?.reimbursementAttachedPositions?.reimbursementAttachedPositions?.map(
                    (item) => item?.id
                  )
                );
              }
              afterCallback?.();
            }
          })
        );
        return;
      }
      if (successCallback) successCallback(response);
    } else if (response?.status !== 200 || error) {
      if (failureCallback) failureCallback();
    }
    if (afterCallback) afterCallback(error);
  };
};

export const setFormAsPartialEventAction = () => {
  return { type: SET_FORM_AS_PARTIAL_EVENT };
};

// clone session
export const cloneSessionEventAction = ({
  payload,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: CREATE_SESSION_STEP1_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "cloneSession",
      params: payload?.params,
    });

    // Legacy returned HTTP 201; the new BE (ResponseInterceptor) forces 200
    // even when the service explicitly sets 201. Accept both: HTTP 200/201 OR
    // body.status === 201 OR presence of responseData.
    const httpOk = response?.status === 200 || response?.status === 201;
    const bodyOk = response?.data?.status === 201 || response?.data?.success === true;
    if (httpOk && bodyOk && response?.data?.responseData) {
      dispatch({
        type: CREATE_SESSION_STEP1_SUCCESS,
        payload: {
          res: {
            data: sessionObjToFormObjHandler({
              session: response?.data?.responseData
            })
          }
        }
      });
      dispatch(
        setSessionStep1FormAction({
          payload: {
            sessionStep1Form: sessionObjToFormObjHandler({
              session: response?.data?.responseData
            })
          }
        })
      );
      dispatch(
        getSessionssOfSpecificEvent(
          getState()?.createContactInfo?.eventInfo?._id,
          () => {
            if (successCallback) successCallback(response?.data?.responseData);
          }
        )
      );
      if (getState()?.auth?.userToken) {
        dispatch(
          addLogAction({
            id: payload?.eventId,
            payload: {
              actionById: getState()?.auth?.userId,
              sessionId: response?.data?.data?._id,
              description: `${response?.data?.data?.sessionName} session is added`
            }
          })
        );
      }
      // if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CREATE_SESSION_STEP1_FAIL });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};
